import { Component, OnInit } from '@angular/core';

@Component({
	selector: 'app-frontpage',
	templateUrl: './frontpage.component.html',
	styleUrls: ['./frontpage.component.css']
})
export class FrontpageComponent implements OnInit {

	constructor() { }

	ngOnInit() { }

}



// WEBPACK FOOTER //
// ./src/app/frontpage/frontpage.component.ts